import React from 'react'
import '../Home/Home.css'
import Clock from "../Home/Clock/Clock"
import img1 from "../../assets/ShortFilm.jpg"
import img2 from "../../assets/LanGaming1.jpeg"
import { Link } from 'react-router-dom'
import {FaUniversity} from "react-icons/fa"
import {MdEmail} from "react-icons/md"
import {AiTwotoneSetting} from "react-icons/ai"
import {IoPeopleSharp} from "react-icons/io5"
import {SiYoutubegaming} from "react-icons/si"
import map from "../../assets/Location.png"
import imgPoster from "../../assets/Poster.jpg"
const Home = () => {
  return (
    <div className='home'>
      <div className="container1">
        <h4 className='clg_name'>College of Engineering and Technology, Akola </h4>
        <h5 className='clg_dep'>Conducted By : CSE Dept.</h5>
        <div className="data">
          <h5>The Tradition Continues</h5>
          <h3>COLLEGE FEST IS BACK !</h3>
          <h3>JOIN US ON </h3>
        </div>
        <div className="countdown">
          <Clock/>
        </div>
      </div>
      <div className="container2" id='About'>
        <h2>ABOUT  TECHNOBLITZ</h2>
        <div className="about_data">
          <h4>TechnoBlitz 2K23 provides young brains a platform to showcase thier innovative ideas and compete with others.This Event explore the ideas to display them and provides fun and learning enviornment . Displaying and Conducting this event will make students learn and feel Impire prove to be the best way of acheiving goal through technology </h4>
          <p>There are various fields which we have in our Tech Fest</p>
          <div className="fields">
            <h3><AiTwotoneSetting className='f_icons'/>Technical</h3>
            <h3><IoPeopleSharp className='f_icons'/>Non-Technical</h3>
            <h3><SiYoutubegaming className='f_icons'/>Gaming</h3>
          </div>
        </div>
      </div>
      <div className="container3">
        <h2>Upcoming Events</h2>
        <div className="events">
          <div className="event_container">
            <Link to="/Movie-Mania">
            <img src={img1} alt="" />
            <h3>Movie Mania</h3>
            </Link>
          </div>
          <div className="event_container">
            <Link to="/Lan">            
            <img src={img2} alt="" />
            <h3>Lan Gaming</h3>
            </Link>
          </div>
        </div>
        <div className="btn">
        <Link to='/events' className='btn_event'>See All Events</Link>
        </div>
      </div>
      <div className="container5">
        <img src={imgPoster} alt="" />
      </div>
      <div className="container4" id='Contact'>
        <h2>CONTACT INFO</h2>
        <div className="flex-container">
          <div className="contact_data">
            <h3><FaUniversity className='icon'/>College Of Engineering & Technology,Akola</h3>
            <h3><MdEmail className='icon'/>technoblitz@coeta.com</h3>
          </div>
          <div className="contact_loc">
            <Link to="https://goo.gl/maps/BM8NCS1jqGmni5KWA" target="_blank">
              <img src={map} alt="" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home